import { render } from "./SkillsSection.vue?vue&type=template&id=a79aca56&scoped=true"
import script from "./SkillsSection.vue?vue&type=script&lang=js"
export * from "./SkillsSection.vue?vue&type=script&lang=js"

import "./SkillsSection.vue?vue&type=style&index=0&id=a79aca56&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79aca56"]])

export default __exports__